import { Spinner } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import PropTypes from "prop-types"
import React from "react"

// https://video-react.js.org/customize/customize-component/
const DownloadButton = (props) => {
  const { className, downloadURL, onClick, loading = false } = props

  const handleClickDownload = (e) => {
    if (onClick && !downloadURL) {
      e.preventDefault()
      e.stopPropagation()
      onClick()
    }
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <a
      className={className}
      onClick={handleClickDownload}
      href={downloadURL}
      download="video"
      target="_blank"
      tabIndex="0"
    >
      <Pathicon
        icon="download"
        style={{
          color: "white",
          fontSize: "1.4em",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          lineHeight: "1.4em",
          height: "100%"
        }}
      />
    </a>
  )
}

DownloadButton.propTypes = {
  player: PropTypes.object,
  className: PropTypes.string
}

export default DownloadButton
